import { createAction } from 'app-components/flux/core/actionHelpers';

export const encryptData = createAction(
  'ENCRYPT_DATA',
  (payload) => payload,
  (payload, meta) => meta,
);
export const encryptDataSuccess = createAction('ENCRYPT_DATA_SUCCESS');
export const encryptDataFailure = createAction('ENCRYPT_DATA_FAILURE');

export const getEncryptionKeySuccess = createAction('GET_ENCRYPTION_KEY_SUCCESS');
export const getEncryptionKeyFailure = createAction('GET_ENCRYPTION_KEY_FAILURE');
